<template lang="pug">
.l-notfound
  .l-notfound__inner
    a.l-notfound__logo
    p.l-notfound__title ページが<br>見つかりませんでした
    p.l-notfound__txt1 アクセスいただいたページは削除されたか、<br>URLが変更されているため、<br>見つけることができません。
    a.l-notfound__btn(href="/") くりからしるべトップへ
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'
.l-notfound
  posf(0,0,1000)
  wh()
  background-color #f6f5f1
  text-align center
  flexc()
  &__inner
    width 640px
    padding-bottom 40px
    position relative
  &__logo
    +pc()
      bg2('../assets/images/ui-tutorial-logo.png')
      posc()
      top -150px
    +sp()
      bg2('../assets/images/ui-tutorial-logo.png',1.8)
      posc()
      top -100px
  &__title
    position relative
    z-index 2
    font_notosans_bold()
    +pc()
      font-size 36px
      line-height 1.3
    +sp()
      font-size 42px
      line-height 1.3
  &__txt1
    position relative
    z-index 2
    +pc()
      font-size 16px
      margin-top 18px
      line-height 1.9
    +sp()
      font-size 24px
      margin-top 35px
      line-height 1.9
  &__btn
    position relative
    z-index 2
    display block
    cursor pointer
    background-color #404040
    color #FFF
    border-radius 15px
    text-align center
    font_notosans_bold()
    +pc()
      wh(300px,45px)
      margin 55px auto 0
      line-height 45px
      font-size 16px
      transition transform 150ms
      &:hover
        transform scale(1.05)
    +sp()
      wh(400px,60px)
      line-height 60px
      font-size 21px
      margin 55px auto 0


</style>


<script>
import { defineComponent, computed, ref, inject ,onMounted, reactive ,onUpdated} from "vue";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  components:{},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    
    return{
    }
  }
})
</script>
